import {
  WALLET_SEARCH,
  WALLET_RESET_SEARCH,
  WALLET_COUNT_TOTAL,
  WALLET_LIST_FETCH_SUCCESS,
  WALLET_DETAIL_FETCH_SUCCESS,
  WALLET_DETAIL_CLEAR,
} from "../actions/types";

const INIT_STATE = {
  search: {
    searchVal: "",
    page: 1,
    perPage: 100,
  },
  countTotal: 0,
  list: [],
  detail: {},
};

export default (state = INIT_STATE, action = {}) => {
  switch (action.type) {
    case WALLET_SEARCH: {
      return {
        ...state,
        search: action.payload,
      };
    }
    case WALLET_RESET_SEARCH: {
      return {
        ...state,
        search: {
          searchVal: "",
          page: 1,
          perPage: 100,
        },
      };
    }
    case WALLET_COUNT_TOTAL: {
      return {
        ...state,
        countTotal: action.payload,
      };
    }
    case WALLET_LIST_FETCH_SUCCESS: {
      return {
        ...state,
        list: action.payload,
      };
    }
    case WALLET_DETAIL_CLEAR: {
      return {
        ...state,
        detail: {},
      };
    }
    case WALLET_DETAIL_FETCH_SUCCESS: {
      return {
        ...state,
        detail: action.payload,
      };
    }
    default:
      return state;
  }
};
